export default "__VITE_ASSET__DqFQAHeB__"